module.exports = __webpack_public_path__ + "static/logo_google_for_startups-dcc1938f4508285050bfbbcbd033d4bf.png";